import React from 'react';
import {
    BillingCommitment,
    useSamplesCatalog,
    getFormattedPrice,
} from '@landr/pricing';
import { Modal, Badge, Text, Image, Button, Flex, Box } from '@landr/maestro';
import { t, Trans } from '@lingui/macro';
import { CONFIG } from 'utils/config';
import { getReturnUrl } from 'helpers';
import { ModalProps } from 'modals/Modal.types';
import * as Styled from './SweetenerUpsellModal.styled';

export const SweetenerUpsellModalContent: React.FC = () => {
    const { data } = useSamplesCatalog();

    const plan = data?.plans?.find(
        ({ frequency }) => frequency === BillingCommitment.Yearly,
    );

    const price = getFormattedPrice({
        value: plan?.subscriptionPrice ?? 0,
        currency: data?.currency || {
            currencyCode: 'USD',
            currencySymbol: '$',
        },
    });

    const discountPercentage = 50;

    const discountPrice = getFormattedPrice({
        value: plan?.subscriptionPrice
            ? (plan?.subscriptionPrice * discountPercentage) / 100
            : 0,
        currency: data?.currency || {
            currencyCode: 'USD',
            currencySymbol: '$',
        },
    });

    const returnUrl = getReturnUrl();
    const couponCode = '50OFFSAMPLES';
    const purchaseUrl = `${CONFIG.VITE_PURCHASE_URL}/${plan?.code}/Yearly/${couponCode}?returnUrl=${returnUrl}`;

    return (
        <Box>
            <Modal.Header>
                <Flex
                    justifyContent="center"
                    alignItems="center"
                    pl="2xl"
                    width="100%"
                >
                    <Badge
                        variant="primary"
                        kind="subtle"
                        isRounded
                        label={t`HOT DEAL - ${discountPercentage}% OFF!`}
                    />
                </Flex>
            </Modal.Header>
            <Modal.Content>
                <Modal.Section p="0">
                    <Box className={Styled.ContentContainer}>
                        <Box className={Styled.HeaderContainer}>
                            <Text textStyle="title-sm" fontWeight="bold">
                                <Trans>Get 6 months for free!</Trans>
                            </Text>
                        </Box>
                        <Box>
                            <Image
                                loading="lazy"
                                src={`${
                                    import.meta.env.BASE_URL
                                }assets/modals/sweetener-packs.png`}
                                width={280}
                                height={180}
                                alt={t`Sweetener packs`}
                            />
                        </Box>
                        <Box className={Styled.TextContainer}>
                            <Text textStyle="body" color="text.medium">
                                <Trans>
                                    Pay {discountPrice} upfront instead of{' '}
                                    {price}
                                </Trans>
                            </Text>
                            <Text textStyle="body" color="text.medium" mt="2xs">
                                <Trans>
                                    Available for a limited time only.
                                </Trans>
                            </Text>
                        </Box>
                    </Box>
                </Modal.Section>
            </Modal.Content>
            <Modal.Footer>
                <Flex justifyContent="center" width="100%">
                    <Button
                        as="a"
                        variant="primary"
                        href={purchaseUrl}
                        mb="xxs"
                        isRounded
                    >
                        <Trans>Get deal</Trans>
                    </Button>
                </Flex>
            </Modal.Footer>
        </Box>
    );
};

export const SweetenerUpsellModal: React.FC<ModalProps> = ({
    handleClose,
    isOpen,
}) => {
    const handleCloseSweetenerModal = () => {
        handleClose();
    };

    return (
        <Modal
            theme="dark"
            isOpen={isOpen}
            onClose={handleCloseSweetenerModal}
            maxWidth="480px"
        >
            <SweetenerUpsellModalContent />
        </Modal>
    );
};

export default SweetenerUpsellModal;
